// has shared html element ids

export const nav_id = "nav"

export const footer_id = "footer"